import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Roberto M.',
    role: 'Líder de Estudio Bíblico',
    location: 'México',
    quote: <span data-id="element-354">
          Llevo 15 años estudiando la Biblia y{' '}
          <span className="font-bold text-burgundy-700" data-id="element-355">
            NUNCA había entendido la geografía
          </span>{' '}
          como ahora. Cuando vi la{' '}
          <span className="highlight-gold font-medium" data-id="element-356">
            reconstrucción 3D de Jerusalén
          </span>{' '}
          en tiempos de Jesús, se me puso la piel de gallina.{' '}
          <span className="italic" data-id="element-357">
            Cada pasaje cobra un significado completamente nuevo.
          </span>
        </span>
  }, {
    name: 'María Elena P.',
    role: 'Maestra de Escuela Dominical',
    location: 'Argentina',
    quote: <span data-id="element-358">
          Compré un atlas bíblico de $90 el año pasado y{' '}
          <span className="italic text-gray-900" data-id="element-359">
            no se compara ni de lejos
          </span>
          . Las imágenes de Biblia Visual son{' '}
          <span className="font-bold text-navy-800" data-id="element-360">increíblemente claras</span>{' '}
          y el contexto arqueológico que incluye es de{' '}
          <span className="highlight-warm font-medium" data-id="element-361">nivel seminario</span>.
          Por $14.99 es{' '}
          <span className="font-bold text-green-700" data-id="element-362">ridículamente bueno</span>.
        </span>
  }, {
    name: 'Pastor Daniel R.',
    role: 'Pastor',
    location: 'Colombia',
    quote: <span data-id="element-363">
          Lo uso cada domingo para preparar mis sermones. Los mapas y las fotos
          reales hacen que mi congregación{' '}
          <span className="font-bold text-navy-800" data-id="element-364">
            entienda los pasajes como nunca antes
          </span>
          . Ya varios miembros me han pedido el enlace para{' '}
          <span className="underline-subtle font-medium" data-id="element-365">
            comprarlo ellos también
          </span>
          .
        </span>
  }];
  return <section className="py-8 md:py-16 bg-parchment-200 content-section" data-id="element-366">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-367">
        <div className="text-center mb-6 md:mb-12" data-id="element-368">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-369">
            Escucha Lo Que Dicen Nuestros Lectores Satisfechos
          </h2>
          <div className="flex justify-center gap-1 text-gold-500" data-id="element-370">
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-371" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-372" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-373" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-374" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-375" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-376">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: Math.min(index * 0.1, 0.3),
          duration: 0.4
        }} className="bg-white p-5 md:p-8 rounded-xl shadow-lg border border-gray-100 relative hover:shadow-xl transition-shadow duration-300" data-id="element-377">
              <Quote className="absolute top-4 right-4 w-10 h-10 text-gold-100" data-id="element-378" />

              <div className="flex items-center mb-4" data-id="element-379">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-navy-900 rounded-full flex items-center justify-center text-white font-bold text-xl mr-4 flex-shrink-0" data-id="element-380">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-381">
                  <h4 className="font-bold text-gray-900" data-id="element-382">{t.name}</h4>
                  <p className="text-xs text-gray-500" data-id="element-383">
                    {t.role} · {t.location}
                  </p>
                </div>
              </div>

              <div className="flex text-gold-500 mb-3" data-id="element-384">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-385" />)}
              </div>

              <p className="text-gray-700 italic leading-relaxed" data-id="element-386">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}